import React, { useEffect, useState, useCallback } from "react";
import "./Layer3Category.scss";
import TableComponent from "../../../components/TableComponent/TableComponent";
import { Button } from "antd";
import ToastHelper from "../../../services/ToastHelper";
import { getApi, postApi } from "../../../utils/apiServices";
import {
  ADD_CATEGORY,
  GET_CATEGORIES_LIST,
  GET_CATEGORY_DROPDOWN,
} from "../../../utils/apiPath";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const Layer3Category = () => {
  const { id, subId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [isLoading, setIsLoading] = useState(false);
  const [categoryData, setCategoryData] = useState(null);

  const handleAdd = () => {
    navigate(`/manage/category/${id}/sub-category/${subId}/layer3/add`, {
      state: {category: location?.state?.category, subCategory : categoryData}
    });
  };

  const handleEditCategory = (subSubId) => {
    navigate(`/manage/category/${id}/sub-category/${subId}/layer3/edit/${subSubId}`, {
      state: {category: location?.state?.category, subCategory : categoryData}
    });
  };

  const handleBack = () => {
    navigate(`/manage/category`);
  };

  const handleBack1 = () => {
    navigate(`/manage/category/${id}/sub-category`, {category: location?.state?.category});
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "media",
      sorter: true,
      render: (media) => (
        <div style={{ width: "60px", height: "60px" }}>
          <img
            style={{ width: "60px", height: "60px", borderRadius: "8px" }}
            src={`${IMAGE_BASE_PATH}${media?.url}`}
            alt={media?.altText}
          />
        </div>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      sorter: true,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          {/* <Button onClick={() => handleViewSubCategories(record?.id)}>
            👁️ View
          </Button> */}
          <Button onClick={() => handleEditCategory(record.id)}>🏀 Edit</Button>
        </div>
      ),
    },
  ];

  const getCategoryData = async () => {
    try {
      const res = await getApi(`${GET_CATEGORY_DROPDOWN}?categoryId=${subId}`);

      if (res?.statusCode === 200) {
        // ToastHelper.success("success");
        setCategoryData(res?.data);
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      // ToastHelper.error(
      //   "Failed to connect to the server. Please try again later."
      // );
    } finally {
      // setIsLoading(false);
    }
    return null;
  };

  useEffect(() => {
    getCategoryData();
  }, []);

  const fetchCategories = async () => {
    const payload = {
      pageIndex: pagination.current - 1,
      pageSize: pagination.pageSize,
      searchString: "",
      parentCategoryId: Number(subId) ?? 0,
    };
    try {
      const res = await postApi(GET_CATEGORIES_LIST, payload);

      if (res?.data?.length !== 0) {
        // ToastHelper.success("success");
        return res;
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      // ToastHelper.error(
      //   "Failed to connect to the server. Please try again later."
      // );
    } finally {
      setIsLoading(false);
    }
    return null;
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    const result = await fetchCategories();
    setData(result?.data);
    setPagination((prev) => ({ ...prev, total: result?.totalRecords }));
    setLoading(false);
  }, [pagination.current, pagination.pageSize]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleTableChange = (newPagination, filters, sorter) => {
    setPagination(newPagination);
  };

  const handleAddCategory = async (data, file, schemas) => {
    const payload = {
      title: data?.title,
      description: data?.description,
      metaTitle: data?.meatTitle,
      metaDescription: data?.metaDescription,
      urlName: data?.pageUrl,
      schema: schemas,
      media: {
        altText: data?.altText,
        media: file?.split(",")[1],
      },
      parentCategoryId: subId ?? 0,
    };

    try {
      const { statusCode, data, message, error } = await postApi(
        ADD_CATEGORY,
        payload
      );

      if (statusCode === 200) {
        ToastHelper.success("success");
        // handleForm();
      } else if (statusCode === 400) {
        ToastHelper.error(
          error || message || "An error occurred. Please try again."
        );
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="categories">
      <div className="categories_container">
        <div className="categories_header">
          <div className="categories_header_left">
            <span onClick={handleBack}>{location?.state?.category?.title}</span>
            <span onClick={handleBack1}> / {categoryData?.title}</span>
            <span className="active"> - Collections</span>
          </div>
          <div className="categories_header_right">
            <Button type="primary" onClick={handleAdd}>
              Add Layer 3
            </Button>
          </div>
        </div>
        <TableComponent
          columns={columns}
          data={data}
          pagination={pagination}
          loading={loading}
          onTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default Layer3Category;
